
<style lang="less" scoped>
@media screen and (min-width: 500px) {
  @import "../../assets/css/pcCom.less";
  .mobile-swiper {
    display: none;
  }
  .card {
    display: none;
  }
  .content {
    background: rgb(248, 248, 241);
    padding: 25px 0;
  }

  .pcBanner img {
    border-radius: inherit !important;
  }
  .images {
    width: 300px !important;
  }
  .information {
    background: #f0f3e2;
    padding: 5px 56px 15px 25px;
    margin-top: 25px;
  }
  .banner {
    display: none;
  }
  .pcGrade {
    margin-top: 25px;
    img {
      width: 30px;
      vertical-align: middle;
      margin-right: 3px;
    }
    h2 {
      margin-bottom: 15px;
      font-size: 20px;
      color: #000000;
    }
    p {
      line-height: 35px;
      color: #333;
      font-size: 18px;

      span {
        width: 100px;
        display: inline-block;
        color: #4b3a0e !important;
        font-weight: 700 !important;
      }
    }
  }

  .literature ul li {
    padding: 8px 0;
  }
  /deep/.ivu-tabs-nav .ivu-tabs-tab {
    font-size: 20px;
    height: 45px;
    color: #333;
  }
  /deep/.ivu-tabs-bar {
    background: #f0f3e2;
  }
}
@media screen and (max-width: 500px) {
  @import "../../assets/css/mobileCom.less";
  .pcBanner {
    display: none;
  }
  .pc-basic {
    display: none;
  }
  .content {
    .images {
      img {
        width: 100px;
        height: 80px;
      }
    }
  }

  .banner {
    text-align: center;
    background: #e6e6e6;
    padding-top: 15px;
    padding-bottom: 5px;

    img {
      width: 350px;
      height: 260px;
    }
  }

  .grade span {
    width: 100px !important;
    display: inline-block;
  }
}
</style>
<template>
  <comHeader></comHeader>
  <div class="content">
    <!-- pc端 -->
    <div class="pcBanner">
      <div class="images">
        <img src="@/assets/image/biaoben.jpg" />
      </div>
      <div class="pcBanner-content">
        <h1>{{ data.vernacularName }}</h1>
        <h2 class="otherName">
          <i>{{ data.scientificName }}</i
          ><span>{{ data.scientificNameAuthorship }}</span>
        </h2>
        <h3 class="parse">
          <a> CSTR:32129.10.2.IBSC.1213234</a>
        </h3>

        <p>
          <span>发现人：</span>
          <span
            style="margin-right: 20px"
            v-for="(item, index) in data.recordedBy"
            :key="index"
            >{{ item }}</span
          >
          <span>发现时间：{{ data.eventDate.substring(0, 10) }}</span>
        </p>
      </div>
    </div>
    <!-- 手机端 -->
    <div class="banner">
      <img src="@/assets/image/biaoben.jpg" />
    </div>
    <!-- 移动端 -->
    <div class="basic">
      <div class="intro card">
        <h2 class="title">{{ data.vernacularName }}</h2>
        <h3 class="otherName">
          <i>{{ data.scientificName }}</i
          ><span>{{ data.scientificNameAuthorship }}</span>
        </h3>
        <h4 class="family">CSTR:32129.46.2.SCBG.67890</h4>
        <p>
          <span>发现人：</span>
          <span
            style="margin-right: 20px"
            v-for="(item, index) in data.recordedBy"
            :key="index"
            >{{ item }}</span
          >
        </p>
        <p>
          <span>发现时间：{{ data.eventDate.substring(0, 10) }}</span>
        </p>
      </div>
      <div class="intro detail">
        <h2><img src="@/assets/image/leaf.png" />学前编码</h2>
        <p>
          <a>CSTR:32129.{{ data.scientificNameID }}</a>
        </p>
      </div>
      <div class="intro detail">
        <h2><img src="@/assets/image/leaf.png" />前体编码</h2>
        <p>
          <a>CSTR:32129.{{ data.previousObjectID }}</a>
        </p>
      </div>
      <div class="intro detail">
        <h2><img src="@/assets/image/leaf.png" />模式信息</h2>
        <p>CSTR:32129.{{ data.typeStatus.holotype }}</p>
        <p>CSTR:32129.{{ data.typeStatus.paratype }}</p>
      </div>
      <div class="intro detail">
        <h2>
          <img src="@/assets/image/leaf.png" style="width: 23px" />相关链接
        </h2>
        <div class="protect-list">
          <p>
            <span>HITBC：</span><a>{{ data.references.HITBC }}</a>
          </p>
          <p>
            <span>中国数字标本馆：</span><br />
            <a>{{ data.references.CVH }}</a>
          </p>
        </div>
      </div>
      <div class="intro detail">
        <h2>
          <img src="@/assets/image/leaf.png" style="width: 23px" />引用方式
        </h2>

        <p class="quote">
          {{ data.scientificNameAuthorship }}
          {{ data.publicationYear }}<i>{{ data.scientificName }}</i> var.
          beipiaoensis in SCBG.
          <a id="copydata">
            https://cstr.cn/32129.45.P.Euonymus.acanthocarpus.CN.SCBG.NOINAME:9705</a
          >
        </p>
      </div>
      <div class="intro detail">
        <h2><img src="@/assets/image/icon-flora.svg" />相关文献</h2>
        <ul>
          <li>
            <span>【1】</span
            ><a
              href="https://kns.cnki.net/kcms2/article/abstract?v=8WLnD7pOpNEvKSinkbJEWGW7kmKG2kLnMWppe47RxUhI3NU1KeYi1b4BbN_QF3GxXg-3k8c0LfxPVfPDZOUs1x_xIQ9kzDqVxNuYjEQhg-1URwyu9-7FCRC_uy31P_HwudwMxuVxklg=&uniplatform=NZKPT&language=CHS"
              >吴德东,周景荣.草牧场防护林对碱草、兴安胡枝子蒸腾效率的影响[J].辽宁林业科技,1994(02):22-23.</a
            >
          </li>
          <li>
            <span>【2】</span
            ><a
              href="https://kns.cnki.net/kcms2/article/abstract?v=8WLnD7pOpNEqe-CAV-KlnV-E4S0Rpdkhvbp1si_pCcnFkQskrZPbkx48YPiSPbIGBRqL98cnbIqPE1tfUcfBNlYDhiutGB9XU71lxkwgxwwxc_ZVpPyiY91SzQJX9YQImL4R89yPvIKQAhqVSeIgYQ==&uniplatform=NZKPT&language=CHS"
              >王永奇,吕琳,姜妍,等.兴安胡枝子化学成分的研究[J].中草药,1992,23(02):63-65+111.</a
            >
          </li>
        </ul>
      </div>
    </div>
    <!-- pc端 -->
    <div class="pc-basic">
      <div class="tablist">
        <Tabs value="name1">
          <TabPane label="基本信息" name="name1">
            <div class="container-right">
              <div class="features">
                <h2><img src="@/assets/image/leaf.png" />学前编码</h2>
                <p>
                  <a>CSTR:32129.{{ data.scientificNameID }}</a>
                </p>
              </div>
              <div class="features">
                <h2><img src="@/assets/image/leaf.png" />前体编码</h2>
                <p>
                  <a>CSTR:32129.{{ data.previousObjectID }}</a>
                </p>
              </div>
              <div class="features">
                <h2><img src="@/assets/image/leaf.png" />模式信息</h2>
                <p>CSTR:32129.{{ data.typeStatus.holotype }}</p>
                <p>CSTR:32129.{{ data.typeStatus.paratype }}</p>
              </div>
              <div class="features">
                <h2><img src="@/assets/image/leaf.png" />行政区划</h2>
                <p>{{ data.higherGeography }}</p>
                <p><span>位置编码：</span>{{ data.locationID }}</p>
                <div id="pcMap"></div>
              </div>
              <div class="features life" id="species">
                <h2><img src="@/assets/image/leaf.png" />相关链接</h2>
                <div class="protect-list">
                  <p>
                    <span>HITBC：</span><a>{{ data.references.HITBC }}</a>
                  </p>
                  <p>
                    <span>中国数字标本馆：</span
                    ><a>{{ data.references.CVH }}</a>
                  </p>
                </div>
              </div>
              <div class="features life">
                <h2><img src="@/assets/image/leaf.png" />引用方式</h2>
                <p class="quote">
                  {{ data.scientificNameAuthorship }}
                  <i>{{ data.scientificName }}</i> var. beipiaoensis in SCBG.
                  <a id="copydata"> https://cstr.cn/10.2.IBSC.1213234</a>
                  <a
                    @click="copyData"
                    id="copyLink"
                    data-clipboard-action="copy"
                    data-clipboard-target="#copydata"
                    ><img src="@/assets/image/copy.png"
                  /></a>
                </p>
              </div>
              <div class="features life" id="species">
                <h2><img src="@/assets/image/leaf.png" />动态属性</h2>
                <div class="protect-list">
                  <table id="data-table">
                    <tbody>
                      <tr
                        v-for="(value, key) in data.dynamicProperties"
                        :key="key"
                      >
                        <td style="width: 200px">{{ key }}</td>
                        <td>{{ value }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </TabPane>

          <TabPane label="图片" name="name2">
            <div class="tabImages">
              <img
                v-for="(item, index) in associatedMedia"
                :src="item"
                :key="index"
              />
            </div>
          </TabPane>
          <TabPane label="物种" name="name3">
            <div class="tabContent">
              <ul>
                <li>
                  <a href="/#" target="_blank"
                    >CSTR:32129.45.P.Euonymus.acanthocarpus.CN.SCBG.NOINAME:9705
                  </a>
                  <span
                    >- <i>{{ data.scientificName }}</i>
                    {{ data.scientificNameAuthorship }}</span
                  >
                  <span>中国 广东省 广州市</span>
                </li>
              </ul>
            </div>
          </TabPane>
          <TabPane label="植株" name="name4">
            <div class="tabContent">
              <ul>
                <li>
                  <a href="/#/users/plant" target="_blank"
                    >CSTR:32129.46.2.SCBG.67890
                  </a>
                  <span
                    >- <i>{{ data.scientificName }}</i>
                    {{ data.scientificNameAuthorship }}</span
                  >
                  <span>中国 广东省 广州市</span>
                </li>
              </ul>
            </div>
          </TabPane>

          <TabPane label="相关文献" name="name6">
            <div class="publication">
              <ul>
                <li>
                  <span> </span
                  ><a
                    href="https://kns.cnki.net/kcms2/article/abstract?v=8WLnD7pOpNEvKSinkbJEWGW7kmKG2kLnMWppe47RxUhI3NU1KeYi1b4BbN_QF3GxXg-3k8c0LfxPVfPDZOUs1x_xIQ9kzDqVxNuYjEQhg-1URwyu9-7FCRC_uy31P_HwudwMxuVxklg=&uniplatform=NZKPT&language=CHS"
                    >吴德东,周景荣.草牧场防护林对碱草、兴安胡枝子蒸腾效率的影响[J].辽宁林业科技,1994(02):22-23.</a
                  >
                </li>
                <li>
                  <span> </span
                  ><a
                    href="https://kns.cnki.net/kcms2/article/abstract?v=8WLnD7pOpNEqe-CAV-KlnV-E4S0Rpdkhvbp1si_pCcnFkQskrZPbkx48YPiSPbIGBRqL98cnbIqPE1tfUcfBNlYDhiutGB9XU71lxkwgxwwxc_ZVpPyiY91SzQJX9YQImL4R89yPvIKQAhqVSeIgYQ==&uniplatform=NZKPT&language=CHS"
                    >王永奇,吕琳,姜妍,等.兴安胡枝子化学成分的研究[J].中草药,1992,23(02):63-65+111.</a
                  >
                </li>
                <li>
                  <span> </span>
                  <a
                    href="https://link.cnki.net/doi/10.27011/d.cnki.gdbsu.2022.000215"
                    target="_blank"
                  >
                    韩佳育.
                    羊草和兴安胡枝子功能性状和种间关系对降水格局变化的响应[D].东北师范大学,2023.DOI:10.27011/d.cnki.gdbsu.2022.000215.</a
                  >
                </li>
                <li>
                  <span></span
                  ><a
                    href="https://link.cnki.net/doi/10.27210/d.cnki.glnju.2021.000301"
                    target="_blank"
                    >李媛.
                    土壤粗化对兴安胡枝子生理生长及种群生态特征的影响[D].辽宁工程技术大学,2022.DOI:10.27210/d.cnki.glnju.2021.000301.</a
                  >
                </li>
                <li>
                  <span></span
                  ><a
                    href="https://kns.cnki.net/kcms2/article/abstract?v=8WLnD7pOpNH4VF0yUfKDGxAGCmoM7BIdgifuwj4VLpHTsi3SnXJfYheMpXaA6_ZTBItQTy58R8hiVyUXQyhpqlpW-9WxRTxpQJdF-e3NdfB5ckNSBPkhH0JPd6-FIFfGBitsLBoBggq-5fL6S8-hMQ==&uniplatform=NZKPT&language=CHS"
                    target="_blank"
                    >顾国海,吕凤春,曾宪楠,等.林下和林缘兴安胡枝子叶片PSⅡ行为对光强的快速响应[J].北方园艺,2018(23):71-79.</a
                  >
                </li>
              </ul>
            </div>
          </TabPane>
        </Tabs>
        <div class="codes-right">
          <div class="ercode">
            <h2>华南植物园</h2>
            <img src="@/assets/image/code1.png" />
            <p><a>下载二维码</a></p>
          </div>
          <div class="ercode">
            <h2>中国科学院植物研究所</h2>
            <img src="@/assets/image/code2.jpg" />
            <p><a>下载二维码</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";
import { onMounted, ref } from "vue";
import comHeader from "@/components/header.vue";
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  components: {
    Swiper,
    SwiperSlide,
    comHeader,
  },
  // 页面创建时
  setup() {
    const map = ref(null);
    const pcMap = ref(null);
    // DOM即将挂载
    onMounted(() => {
      AMapLoader.load({
        key: "4c55cd3ae4b3d135bf859e12bb737194", // 高德地图API Key
        version: "2.0", // 指定API版本
        plugins: ["AMap.Geolocation", "AMap.PlaceSearch", "AMap.Scale"], // 需要使用的插件
        AMapUI: {
          // 是否加载AMapUI，及版本
          version: "1.1",
          plugins: [],
        },
      })
        .then((AMap) => {
          pcMap.value = new AMap.Map("pcMap", {
            zoom: 6.5, // 初始化地图缩放级别
            center: [114.14, 23.08], // 初始化地图中心点
          });
          const marker = new AMap.Marker({
            position: [114.14, 23.08], // 标记点的位置
            map: pcMap.value, // 要
          });
        })

        .catch((e) => {
          console.log(e);
        });
    });

    return {
      pcMap,
    };
  },
  data() {
    return {
      associatedMedia: [],
      data: require("@/assets/data/plant.json").specimen,
    };
  },
  mounted() {
    this.associatedMedia = Object.values(this.data.associatedMedia);
    const swiper3 = new this.$Swiper(".pc-swiper", {
      loop: true,
      autoplay: true,
      direction: "vertical",
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    const swiper = new this.$Swiper(".mySwiper2", {
      spaceBetween: 10,
      loop: true,
      autoplay: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiper2,
      },
    });
    var swiper2 = new this.$Swiper(".mySwiper", {
      spaceBetween: 5,
      slidesPerView: 4,
      freeMode: true,
      loop: true,
      autoplay: true,
      watchSlidesProgress: true,
      autoScrollOffset: 1,
    });
  },
  methods: {},
};
</script>